export enum OperatorFilterStringEnums {
  Equal = "eq",
  NotEqual = "ne",
  NotContain = "not",
  Contain = "contains",
  Null = "null",
}

export enum OperatorFilterNumberEnums {
  Equal = "eq",
  Less = "lt",
  Greater = "gt",
  LessOrEqual = "le",
  GreaterOrEqual = "ge",
  Null = "null",
}

export enum FilterType {
  Filter = "Filter",
  Sort = "Sort",
}

export enum OrderValue {
  asc = "asc",
  desc = "desc",
}

export enum PAGING {
  Page = 1,
  Size = 20,
}
export enum SORTING {
  Ascending = "asc",
  Descending = "desc",
}
export enum SelectionMode {
  None = "none",
  Multiple = "multiple",
  Single = "single",
}